// extracted by mini-css-extract-plugin
module.exports = {"poster":"Poster_poster__W-ig6","imgBox":"Poster_imgBox__3Mf5o","smallPoster":"Poster_smallPoster__1p0tI Poster_poster__W-ig6"};